import React from 'react';
import { string, bool, number, node, oneOfType } from 'prop-types';
import ReactPlaceholder from 'react-placeholder';

import 'react-placeholder/lib/reactPlaceholder.css';

export const LoadingPlaceholder = ({ ready, type, className, height, width, children }) => (
    <ReactPlaceholder showLoadingAnimation type={type} ready={ready} className={className} style={{ width, height }}>
        {children}
    </ReactPlaceholder>
);

LoadingPlaceholder.propTypes = {
    ready: bool,
    type: string,
    className: string,
    height: oneOfType([number, string]),
    width: oneOfType([number, string]),
    children: node,
};
